<template> <!-- #Pendiente eliminar antiguas NavBar y NewNavbarFactoring -->
	<div class="dashboard-navbar">
		<!-- Menu Btn -->
		<v-layout wrap row align-start justify-start style="position:fixed;z-index:1;margin: 10px">
			<v-flex xs12 @click="setOpenMenu()">
				<v-icon class="rc-menuPanelBtn">menu</v-icon>
			</v-flex>
		</v-layout>
		<!-- List Menu -->
    	<v-navigation-drawer id="rc-menuPanel" v-model="drawer" fixed class="rc-menuDrawer">
			<v-list v-if="tipo_menu === 3" class="transparent pa-2">
        		<!-- Mi Panel -->
				<v-flex v-for="(panelSolicitanteMenu, index) in panelSolicitanteMenus" :key="`${panelSolicitanteMenu.icon}-${index}`">
					<v-list-tile  v-if="valMisDatos && panelSolicitanteMenu.text == 'Mis claves y certificados'"
					class="v-list-item rc-listItem-pad" :class="stateOptionMisClaves" :active-class="activeClassMenuAlert" :to="panelSolicitanteMenu.to.path">
						<div style="text-align: center; width: 100%; line-height: 1; display: flex; flex-direction: row; align-items:center; ">
							<div style="flex-basis: 90%;" class="custom-margin">
								<span class="rc-listItem-img material-icons-outlined " style="height:26px;width:26px">{{ panelSolicitanteMenu.icon }}</span>
								<div class="rc-listItem-title">{{ panelSolicitanteMenu.text }}</div>
							</div>
						</div>
					</v-list-tile>
					<v-list-tile v-else class="v-list-item rc-list-item rc-listItem-pad" :active-class="activeClassMenu" :to="panelSolicitanteMenu.to.path">
						<div style="text-align: center; width: 100%; line-height: 1;">
							<span class="rc-listItem-img material-icons-outlined" style="height:26px;width:26px">{{ panelSolicitanteMenu.icon }}</span>
							<div class="rc-listItem-title">{{ panelSolicitanteMenu.text }}</div>
						</div>
					</v-list-tile>
				</v-flex>
				
			</v-list>
		</v-navigation-drawer>
	</div>
</template>

<script>
	import { Component, Vue } from "vue-property-decorator";
	import { mapState } from "vuex";
	import { panelSolicitanteMenus } from "@/models/DashboardLinks";
	
	@Component({
		props: {
			// datos
			tipo_menu: Number,
			sii: Boolean,
			certificado: Boolean,
			estadoCertificado: String,
			estadoPerfil:Boolean

        },
		computed: {
			...mapState(["user", "setOpenMenuPanel", "siiConfigurations", "claveSii","certificadoSii"]),
			activeClassMenu() {
				return "rc-menuPanelActive";
			},
			activeClassMenuAlert(){
				if((this.$props.sii == false && this.$props.certificado == true) || (this.$props.sii == false && this.$props.certificado == false) || (this.$props.sii == true && this.$props.certificado == false) || (this.$props.sii == true && this.$props.certificado == true && this.$props.estadoCertificado == 'EXPIRADO')){
					return "rc-listItem-alert-active";
				}
				else if(this.$props.certificado == true && this.$props.estadoCertificado == 'POR EXPIRAR' && this.$props.sii == true){
					return 'rc-listItem-warning-active';
				}
			},
			stateOptionMisClaves(){
				if(this.$props.certificado == true && this.$props.estadoCertificado == 'POR EXPIRAR' && this.$props.sii == true){
					return 'rc-listItem-warning rc-text-color-warning';
				}
				else{
					return 'rc-listItem-alert rc-text-color-alert'	
				}
			},
			valMisDatos(){
				return (this.$props.sii == false && this.$props.certificado == false) || (this.$props.sii == true && this.$props.certificado == false) || (this.$props.sii == false && this.$props.certificado == true) || (this.$props.sii == true && this.$props.certificado == true && this.$props.estadoCertificado == 'POR EXPIRAR') || (this.$props.sii == true && this.$props.certificado == true && this.$props.estadoCertificado == 'EXPIRADO')
			}
		},
		data() { // Data Menu
			return {
				// Menu Solicitante general
				panelSolicitanteMenus,
				title: null,
				drawer: false,
				responsive: false,
				dark: true,
				show: false,
			}
		},
		// beforeMount() {}, // Antes de Montar el componente
		// beforeUpdate(){}, // Antes de Actualizar el componente
		mounted(){
			 // @ts-ignore
			this.onResponsive();
			// @ts-ignore
			window.addEventListener("resize", this.onResponsive);
			
		},
		methods:{
			onResponsive() {
				var url = window.location.pathname;
				let valPreguntasPefil = url === '/panel/preguntas-perfil' ? false : true;
				if (window.innerWidth >= 1264){
					this.hasClassMenu();
					this.drawer = true;
					if(this.$props.tipo_menu === 3 && valPreguntasPefil === true){
						this.$store.commit("setOpenMenuPanel", true);
					}
				}
				if (window.innerWidth < 960) {
					this.$data.responsive = true;
				} else {
					this.$data.responsive = false;
				}
			},
			setOpenMenu(){
				if(this.$data.drawer){
					this.drawer = false;
					this.$store.commit("setOpenMenuPanel", false);
				}else{
					this.drawer = true;
					this.$store.commit("setOpenMenuPanel", true);
				}
			},
			hasClassMenu(){
				// Guard: en el wizard BCI (sin sidebar) o durante el desmonte del drawer,
				// #rc-menuPanel no existe -> antes reventaba "Cannot read className of null".
				const menu = document.getElementById('rc-menuPanel');
				if(menu && menu.className.match(/\bv-navigation-drawer--open\b/)){
					this.drawer = true;
					this.$store.commit("setOpenMenuPanel", true);
				}else{
					this.drawer = false;
					this.$store.commit("setOpenMenuPanel", false);
				}
			}
		}
	})
	export default class SideBarPanel extends Vue {}
</script>

<style lang="scss" scoped>
	.rc-menuPanelBtn{
		cursor: pointer; 
		color: $rc-prim-n1;
	}

	.rc-listItem-title{
		font-weight: 600;
	}

	.v-list{
		padding: 5px 0px !important;
	}
	
	.rc-listItem-pad{
		padding: 5px 5px;
	}
	.rc-text-color-alert{
		color: #E83F29 !important;
	}
	.rc-text-color-warning{
		color: #FFD541 !important;
	}
	
	/* Menu */
	.rc-list_ico{
		height: 20px;
		width: 20px;
	}
	.rc-right-bar{
		height: calc(100vh - 64px);
		background-color: $rc-escala5;
	}

	.rc-noml{
		margin-left: 0 !important;
	}

	.rc-menuDrawer{
		top: auto;
		//margin-top:64px !important;
		z-index:1; 
		width:150px !important; 
		height: calc( 100vh - 64px ) !important; 
		min-height: calc( 100vh - 64px ) !important; 
	}

	// Breakpoints 
	@each $breakpoint in $breakpoints_screen_text{
		@include breakpoint_media_queries($breakpoint){
			@if $breakpoint == "x-large"{
				
			}@else if $breakpoint == "large"{
				
			}@else if $breakpoint == "medium-to-large"{
				.rc-menuDrawer{
					margin-top: 0 !important;
					z-index: 5;
					width: 300px !important;
					height: 100vh !important; 
					min-height: 100vh !important;
				}
				.rc-listItem-img{
					float: left;
				}
				.rc-listItem-title{
					float: left;
					line-height: 2;
					margin-left: 10px;
				}
			}@else if $breakpoint == "small-to-medium"{
				.rc-menuDrawer{
					margin-top: 0 !important;
					z-index: 5;
					width: 300px !important;
					height: 100vh !important; 
					min-height: 100vh !important;
				}
				.rc-listItem-img{
					float: left;
				}
				.rc-listItem-title{
					float: left;
					line-height: 2;
					margin-left: 10px;
				}
			}@else if $breakpoint == "small"{
				.rc-menuDrawer{
					margin-top: 0 !important;
					z-index: 5;
					width: 300px !important;
					height: 100vh !important; 
					min-height: 100vh !important; 
				}
				.rc-listItem-img{
					float: left;
				}
				.rc-listItem-title{
					float: left;
					line-height: 2;
					margin-left: 10px;
				}
			}
		}
	}
	@media (min-width:1264px) {

    .custom-margin{
      margin-left: 5px;
	}
  }
  @media (max-width:1264px) {

    .custom-margin{
      margin-left: 0px;
    }
  }
  .disabled-tile {
	opacity: 0.5;
	pointer-events: none;
	cursor: default;
	transition: opacity 0.3s ease-in-out;
	}
</style>
